export default __webpack_public_path__ + "static/media/Discord-Logo+Wordmark-Color.660fe2e8.png";